import React, { PureComponent } from 'react';
import { Input, Icon } from '@ss/mtd-react';
import "./style.scss"
import classnames from "classnames";
import urls from '@/urls';
import { fetchData } from '@/utils';

export default class index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            recentSearchList: [],
            hotSearchList: [],

            recentSearchPagination: {
                currentPage: 1,
                pageSize: 10,
                pages: 1,
                total: 0
            },
            hotSearchPagination: {
                currentPage: 1,
                pageSize: 10,
                pages: 1,
                total: 0
            }
        }
    }
    componentDidMount() {
        this.getRecentSearch();
        this.getHotSearch();
    }

    getRecentSearch = async () => {
        const userMis = localStorage.getItem("userMis");
        const { recentSearchPagination } = this.state;
        const param = {
            currentPage: recentSearchPagination.currentPage,
            pageSize: recentSearchPagination.pageSize,
            userMis
        }
        const res = await fetchData(urls.search.getSearchRecord, param);
        const { pageList, pagination } = res;
        this.setState({
            recentSearchList: pageList,
            recentSearchPagination: pagination
        })
    }

    getHotSearch = async () => {
        const { hotSearchPagination } = this.state;
        const param = {
            currentPage: hotSearchPagination.currentPage,
            pageSize: hotSearchPagination.pageSize,
        }
        const res = await fetchData(urls.search.getHotSearchRecord, param);
        const { pageList, pagination } = res;
        this.setState({
            hotSearchList: pageList,
            hotSearchPagination: pagination
        })
    }

    handleDeleteRecentSearch = async (e) => {
        e.stopPropagation();
        const { recentSearchList } = this.state;
        const idList = recentSearchList.map(item => item.id);
        await fetchData(urls.search.deleteSearchRecord, { idList });
        this.setState({
            recentSearchList: [],
            recentSearchPagination: {
                currentPage: 1,
                pageSize: 10,
                pages: 1,
                total: 0
            },
            hotSearchPagination: {
                currentPage: 1,
                pageSize: 10,
                pages: 1,
                total: 0
            }
        }, () => {
            this.getRecentSearch();
            this.getHotSearch();
        })
    }

    changeHotSearch = (e) => {
        e.stopPropagation();
        const { hotSearchPagination } = this.state;
        const { currentPage, pages } = hotSearchPagination;
        if (currentPage >= pages) {
            return
        }
        this.setState({
            hotSearchPagination: {
                ...hotSearchPagination,
                currentPage: currentPage + 1
            }
        }, this.getHotSearch)
    }

    handleSelect = (item) => {
        const { handleSelectKeyword } = this.props;
        handleSelectKeyword(item.keyword || item)
    }


    render() {
        const { style, theme } = this.props;
        const { recentSearchList, hotSearchList, hotSearchPagination } = this.state;
        return (
            <div className='recent-search-wrap'>
                <div className='global-search-content-title'>
                    <span>最近搜索</span>
                    <span>|</span>
                    <span onClick={this.handleDeleteRecentSearch} className={recentSearchList.length === 0 ? 'not-allow-search' : ''}><Icon type="delete-o"></Icon>清除所有</span>
                </div>
                <ul className='global-search-content'>
                    {
                        recentSearchList.map(item => (
                            <li key={item.id} onClick={() => this.handleSelect(item)}>{item.keyword}</li>
                        ))
                    }
                </ul>
                <div className='global-search-content-title' style={{ marginTop: 20 }}>
                    <span>热门搜索</span>
                    <span>|</span>
                    <span onClick={this.changeHotSearch} className={hotSearchPagination.currentPage >= hotSearchPagination.pages ? 'not-allow-search' : ''}><Icon type="cycle"></Icon>换一批</span>
                </div>
                <ul className='global-search-content'>
                    {
                        hotSearchList.map((item, index) => (
                            <li key={index} onClick={() => this.handleSelect(item)}>{item.keyword}</li>
                        ))
                    }
                </ul>
            </div>
        )
    }
}
